// extracted by mini-css-extract-plugin
module.exports = {"landingPageDialog":"landingPage_landingPageDialog__2rdeH","header":"landingPage_header__3yz66","description":"landingPage_description__2Llpp"};